var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_vm._v(" 工艺图 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }